import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from '../../services/auth.service.js';
import Swal from 'sweetalert2';

export const ResetPasswordAuto = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = searchParams.get('hash');
    if (!hash) {
      navigate('/', { replace: true });
      return;
    }

    const processReset = async () => {
      Swal.fire({
        title: 'Procesando solicitud...',
        text: 'Por favor espere un momento.',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await new Promise((resolve) => setTimeout(resolve, 5000));

      try {
        await confirmPasswordReset(hash);

        // ✅ Limpiar el hash de la URL antes de redirigir
        window.history.replaceState({}, document.title, window.location.pathname);

        Swal.fire({
          icon: 'success',
          title: '¡Contraseña reseteada!',
          text: 'Revisá tu correo para obtener tu nueva contraseña provisoria.',
          timer: 5000,
          timerProgressBar: true,
          willClose: () => {
            navigate('/', { replace: true });
          },
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al procesar la solicitud. El link podría haber expirado.',
          confirmButtonText: 'Volver',
        }).then(() => {
          navigate('/forgot-password', { replace: true });
        });
      }
    };

    processReset();
  }, [searchParams, navigate]);

  return null;
};
